import { Befehl } from '../models'
import { findAuftrag, hasFieldContent } from './helpers'
import { hasBefehlGenericEmptyFields } from './generic'

/**
 * Checks if Befehl 28 has empty fields.
 *
 * First checks if ANY field is empty (generic check).
 * Then checks specific business rules:
 * - 28.10 auftrag: 28.11 etcsLevel field must have content
 * - 28.20 auftrag: 28.21 etcsBetriebsart field must have content
 *
 * Aufträge without felder are never considered to have empty fields.
 * Boolean field values are never considered empty fields.
 */
export function hasBefehl28EmptyFields(befehl: Befehl): boolean {
  if (!befehl?.auftraege?.length) return false

  // First check if ANY field is empty
  if (hasBefehlGenericEmptyFields(befehl)) {
    return true
  }

  // Then check specific business rules
  const auftrag2810 = findAuftrag(befehl, '28.10')
  const auftrag2820 = findAuftrag(befehl, '28.20')

  // Check if 28.10 exists and has empty etcsLevel
  if (auftrag2810 && !hasFieldContent(auftrag2810, '28.11', 'etcsLevel')) {
    return true
  }

  // Check if 28.20 exists and has empty etcsBetriebsart
  if (
    auftrag2820 &&
    !hasFieldContent(auftrag2820, '28.21', 'etcsBetriebsart')
  ) {
    return true
  }

  return false
}
